import React from 'react';
import Icon from "components/ui/AppIcon.jsx";
import Button from '../../../components/ui/Button.jsx';

const FilterControls = ({ 
  selectedSegment, 
  onSegmentChange, 
  selectedPeriod, 
  onPeriodChange,
  comparisonMode,
  onComparisonToggle,
  onExport,
  lastUpdated 
}) => {
  const segments = [
    { value: 'all', label: 'Todos los Segmentos' },
    { value: 'premium', label: 'Premium' },
    { value: 'standard', label: 'Estándar' },
    { value: 'basic', label: 'Básico' }
  ];

  const periods = [
    { value: 'q1', label: 'Q1 2024' },
    { value: 'q2', label: 'Q2 2024' },
    { value: 'q3', label: 'Q3 2024' },
    { value: 'q4', label: 'Q4 2024' },
    { value: 'ytd', label: 'Año Completo' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Left Side - Filters */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
          {/* Segment Filter */}
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={16} className="text-muted-foreground" />
            <select
              value={selectedSegment}
              onChange={(e) => onSegmentChange(e?.target?.value)}
              className="text-sm border border-border rounded-md px-3 py-1.5 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              {segments?.map(segment => (
                <option key={segment?.value} value={segment?.value}>
                  {segment?.label}
                </option>
              ))}
            </select>
          </div>

          {/* Period Filter */}
          <div className="flex items-center space-x-2">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <select
              value={selectedPeriod}
              onChange={(e) => onPeriodChange(e?.target?.value)}
              className="text-sm border border-border rounded-md px-3 py-1.5 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              {periods?.map(period => (
                <option key={period?.value} value={period?.value}>
                  {period?.label}
                </option>
              ))}
            </select>
          </div>

          {/* Comparison Toggle */}
          <button
            onClick={onComparisonToggle}
            className={`flex items-center space-x-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              comparisonMode 
                ? 'bg-primary text-primary-foreground' 
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            <Icon name="GitCompare" size={16} />
            <span>Comparar Años</span>
          </button>
        </div>

        {/* Right Side - Actions & Status */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
          {/* Last Updated */}
          <div className="flex items-center space-x-2 text-xs text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>Actualizado: {lastUpdated}</span>
          </div>

          {/* Export Buttons */}
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onExport('excel')}
              iconName="FileSpreadsheet"
              iconPosition="left"
              iconSize={14}
            >
              Excel
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onExport('pdf')}
              iconName="FileText"
              iconPosition="left"
              iconSize={14}
            >
              PDF
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;
